export const URLS = {
  base_url: 'https://querobolsa.com.br/enem',
  manual_enem_url: '/enem/manual-do-enem',
  gabarito_url: '/enem/gabarito',
  querobolsa_url: 'https://querobolsa.com.br',
}
